import {Search} from '@mui/icons-material'
import {FilledInput, FormControl, Input} from '@mui/material'
import {styled} from '@mui/material/styles'
import theme from '../../../themes/index'

export const StyledFormControl = styled(FormControl)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: 'auto',
  flexDirection: 'row'
}))

export const StyledSearchIcon = styled(Search)(() => ({
  color: 'grey'
}))

export const StyledFilledInput = styled(FilledInput)(({theme}) => ({
  backgroundColor: theme.palette.common.black,
  color: theme.palette.greyShade,
  fontSize: '14px',
  width: '100%',
  borderRadius: '5px',
  '& .MuiFilledInput-input': {
    paddingTop: '8px'
  },
  '&.Mui-focused': {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.greyShad
  },
  '&:hover': {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.greyShad
  }
}))

export const StyledInput = styled(Input)(() => ({
  flexGrow: 1,
  color: 'grey',
  '&:before': {borderBottomColor: 'grey'}
}))

export const filledInputStyle = {
  focused: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.greyShade
  }
}
